export default function getData (data) {
    return {
        color: ['#00ffff', '#0c7ffe', '#fc79f2', '#ff00ff'],
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {d}%'
        },
        legend: {
            orient: 'vertical',
            left: 'left',
            data: data.legendData,
            textStyle: {
              color: '#fff',
              fontSize: 10
            },
            icon: 'circle',
            itemWidth: 6,
            itemHeight: 6
        },
        series: [
            {
                type: 'pie',
                hoverAnimation:false,
                radius: ['20%', '40%'],
                center: ['60%', '50%'],
                avoidLabelOverlap: false,
                label: {
                  normal: {
                    show: true,
                    textStyle: {
                      color: '#fff'
                    },
                    padding: [0, -30],
                    formatter: '{d}%'
                  },
                },
                labelLine: {
                  show: false
                },
                itemStyle: {
                  borderWidth: 2,
                  borderColor: '#1b2338'
                },
                data: data.seriesData
            }
        ]
    }
}


// WEBPACK FOOTER //
// ./src/views/dataIndex/data/equipmentFailureRate.js